// extracted by mini-css-extract-plugin
export default {"loader":"CustomPageLoader_loader__lE2i0","spin":"CustomPageLoader_spin__lGgH+","overlayed":"CustomPageLoader_overlayed__v2aqq","overlay":"CustomPageLoader_overlay__39LhA"};